<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('railing.editor_title')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div class="row" v-if="!this.isAddEquipmentMode">
                    <div class="col-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('post.type') }}</span>
                        <select
                            v-model="item.type"
                            :class="['form-select', { 'is-invalid': !item.type }]"
                            id="type"
                            size="sm"
                        >
                            <option value="" disabled>{{ $t('post.select_type') }}</option>
                            <option
                                v-for="item in getRailingTypes()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('railing.post_type.title') }}</span>
                        <select
                            v-model="item.post_type"
                            class="form-select form-select-sm"
                        >
                            <option value="" disabled>{{ $t('railing.post_type.select_type') }}</option>
                            <option
                                v-for="item in getRailingPostTypes()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition" :required="true"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('railing.material') }}</span>
                        <select
                            v-model="item.material"
                            class="form-select form-select-sm"
                        >
                            <option value="" disabled>{{ $t('railing.select_material') }}</option>
                            <option
                                v-for="item in getMaterials()"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('post.height') }}</span>
                        <input
                            id="height"
                            type="number"
                            min="1"
                            v-model="item.height"
                            class="form-control form-control-sm"
                        />
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('post.code') }}</span>
                        <input
                            id="code"
                            type="text"
                            v-model="item.code"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 nopads pr-1">
                        <span class="span-title">{{ $t('post.product_name') }}</span>
                        <input
                            id="productName"
                            type="text"
                            v-model="item.product_name"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="row px-2">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
                <!-- TODO - Railings don't have point based actions(?)
                    <equipment-actions ref="actions" v-model="item.actions" />
                 -->
                <template v-if="this.isAddEquipmentMode">
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.starting_position') }}</span>
                        </div>
                        <div class="col-sm-12">
                            <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                            :tracksRequired="false"
                            :hideTracksSelector="true"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.ending_position') }}</span>
                        </div>
                        <div class="col-sm-12 nopads">
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item.location_ending"
                            :locationSpecification="item.location_specification_ending"
                            :tracksRequired="false"
                            :hideTracksSelector="true"
                            :sideRequired="false"
                            :hideSideSelector="true"
                            />
                        </div>
                    </div>
                </template>
                <hr class="mb-0">
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('velho_equipment.start_date')"
                            v-model="item.created_at"
                        />
                    </div>
                </div>
                <linked-equipment
                    v-if="item.linked_equipment && item.linked_equipment.length > 0"
                    :linked-equipments="item.linked_equipment"
                />
            </div>
            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extRailingsUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {railingHelper} from "@/components/mixins/RailingMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'RailingEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, LocationDetails, VelhoEditorButtons, ConditionSelector, LinkedEquipment, VelhoEquipmentLocationDetailsEditor},
    mixins: [velhoHelper, mapHelper, railingHelper, conversionModelHelper, restApi, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateRoadNumber(this.item.location_ending.road_num)) { return false }
            if(!this.validateRoadSection(this.item.location_ending.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.location_ending.distance)) { return false }
            if(!this.validateRoadSide(this.item.location_specification.side)) { return false }

            return true;
        }
    }
}
</script>

<style scoped>
.map-container {
    height: 30em;
    position: relative;
}

</style>

